import React from "react";
import { branch } from "baobab-react/higher-order";
import Simplert from "react-simplert";
import { dismissAlert } from "../actions/alertActions";
import _ from "lodash";

import * as Utils from "../utils/utils";

class Alerts extends React.Component {

	constructor(props) {
		super(props);
		this.refreshCount = 0;
	}

	handleDismiss() {
		dismissAlert();
	}

	// Biggest hack ever...needs to be better way
	componentDidUpdate() {
		if (this.refreshCount % 2 === 0) {
			this.forceUpdate();
		}
		this.refreshCount++;
	}

	render() {
		let alerts = [];
		const self = this;
		this.props.alerts.forEach((alert, idx) => {

			let opts = {
				showSimplert: true,
				customCloseBtnText: "OK",
				onClose: self.handleDismiss.bind(self),
				disableOverlayClick: true,
				type: alert.type === "danger" ? "error" : alert.type
			};

			if (alert.title && alert.title !== "") {
				opts.title = alert.title;
			}

			if (alert.onConfirm) {
				opts.onConfirm = self.handleDismiss.bind(self);
				opts.useConfirmBtn = true;
				opts.onClose = function () { self.handleDismiss(); alert.onConfirm(); };
				opts.customConfirmBtnText = "Cancel";
				opts.customConfirmBtnClass = "simplert-button-transparent";
				opts.customCloseBtnText = "OK";
				opts.customCloseBtnClass = "simplert-button-orange";
				opts.type = "warning";
			}

			if (alert.onYesNo) {
				opts.onConfirm = self.handleDismiss.bind(self);
				opts.useConfirmBtn = true;
				opts.onClose = function () { self.handleDismiss(); alert.onYesNo(); };
				opts.customConfirmBtnText = "No";
				opts.customConfirmBtnClass = "simplert-button-transparent";
				opts.customCloseBtnText = "Yes";
				opts.customCloseBtnClass = "simplert-button-orange";
				opts.type = "warning";
			}

			if (alert.callback) {
				opts.onClose = function () { self.handleDismiss(); alert.callback(); };
			}

			if (alert.hasOwnProperty("message")) {
				let message = null;
				if (_.isString(alert.message)) {
					message = alert.message;
				} else if (_.isObject(alert.message) && alert.message.hasOwnProperty("message")) {
					message = alert.message.message;
				}
				
				if (message) {
					alerts.push(<Simplert key={`alert-${idx}`}
						{...opts} message={Utils.truncateWithEllipses(message, 1000)} />);
				} else {
					alerts.push(<Simplert key={`alert-${idx}`}
						{...opts} message={""} />);
				}
				
			} else {
				console.error("Not a string", alert);
			}
		});

		return (
			<div>
				{alerts}
			</div>
		);
	}

}

export default branch(() => {
	return {
		alerts: ["appState", "alerts"]
	};
}, Alerts);